module.exports = __webpack_public_path__ + "img/architectural-evolution-2.7f7b660d.png";